import { computed as y, toValue as w, watch as U, ref as S, provide as K, inject as O, onMounted as ae, onUnmounted as ne, defineComponent as M, useModel as R, openBlock as g, createBlock as k, unref as a, mergeModels as Y, createElementBlock as C, withCtx as f, renderSlot as v, createTextVNode as V, toDisplayString as h, createCommentVNode as L, normalizeProps as ge, guardReactiveProps as Ve, withDirectives as xe, vShow as qe, Fragment as ie, createVNode as N, createElementVNode as oe, normalizeClass as $e } from "vue";
import { useAppI18n as I, useApplicationStore as z, localDate as G, validatePAN as ke, reportCustomError as Fe, useFieldStore as Ce, reportSessionError as Se, useAppFieldResponse as re, States as Me, Countries as Ae, formatDate as Te, useSessionStore as Ie, formatCurrency as J } from "@versatile-credit-apply/sdk";
import { useOmniApplyApiClient as Z, BadRequestException as we, ApplicantType as Ue } from "@versatile-credit-apply/omni-apply-client";
import { createRule as De, useRegle as Pe } from "@regle/core";
import { useI18n as P } from "vue-i18n";
import { useValidationRules as Be } from "@ui-kit/components";
import { withMessage as D, withAsync as Ee, matchRegex as Re, minValue as Le, maxValue as Ne, withParams as ze, isEmpty as Q } from "@regle/rules";
import Oe from "@ui-kit/components/input-checkbox";
import je from "@ui-kit/components/input-currency";
import j from "@ui-kit/components/input-dropdown";
import Ke from "@ui-kit/components/input-number";
import Ye from "@ui-kit/components/input-postal-code";
import Ge from "@ui-kit/components/input-ssn";
import _ from "@ui-kit/components/input-text";
import Ze from "@ui-kit/components/input-phone";
import ue from "@ui-kit/components/input-email";
import He from "@ui-kit/components/input-date";
import de from "@ui-kit/components/select-button";
import We from "@ui-kit/components/input-signature-pad";
import { useOptionalFieldController as Xe } from "@versatile-credit-apply/composition";
import Je from "@ui-kit/components/form";
import Qe from "@ui-kit/components/modal";
import _e from "primevue/inputnumber";
import et from "@ui-kit/components/error-text";
const ee = (e, l) => {
  let t = "";
  return e > 0 && (t += "!*".repeat(e)), l > 0 && (t += "#".repeat(l)), t;
}, tt = (e) => e <= 8 ? "!*!*!*!*-####" : e <= 12 ? "!*!*!*!*-!*!*!*!*-####" : e <= 16 ? "!*!*!*!*-!*!*!*!*-!*!*!*!*-####" : "!*!*!*!*-!*!*!*!*-!*!*!*!*-!*!*!*!*-###", lt = (e, l) => {
  if (e === "all")
    return ee(l.length, 0);
  if (e === "last4" && l.length > 4)
    return ee(l.length - 4, 4);
  if (e === "pan")
    return tt(l.length);
}, at = (e, l) => y(() => {
  const t = w(l), i = e.value;
  if (t && typeof i == "string")
    return typeof t == "function" ? t(i) : lt(t, i);
}), nt = (e) => {
  const { t: l, te: t } = I({
    useScope: "parent"
  });
  return y(() => {
    const i = e.value?.id;
    if (t(`appFields.${i}.label`))
      return l(`appFields.${i}.label`);
    const p = `appFields.${e.value?.name}.label`;
    return t(p) ? l(p) : p;
  });
}, it = (e) => {
  const { t: l, te: t } = I({
    useScope: "parent"
  });
  return y(() => {
    const i = e.value?.name;
    if (t(`appFields.${i}.description`))
      return l(`appFields.${i}.description`);
    const p = `appFields.${e.value?.id}.description`;
    return t(p) ? l(p) : void 0;
  });
}, se = (e) => {
  const l = z(), t = y({
    get() {
      const i = w(e);
      if (i) {
        const r = l.getApplicationValue(i);
        return r === null ? void 0 : r;
      }
    },
    set(i) {
      const r = w(e);
      r && (typeof i == "string" && (i = i.trim()), (i === void 0 || i === "") && (i = null), l.setApplicationValue(r, i));
    }
  });
  return U(
    () => w(e),
    (i, r) => {
      r && i && (t.value = l.getApplicationValue(r), l.setApplicationValue(r, void 0));
    }
  ), t;
}, ot = (e) => e.rules.some((l) => l.id === "disabled") ? !0 : void 0, rt = (e) => {
  if (e.rules.find(({ id: l }) => l === "required"))
    return !0;
}, ut = () => {
  const e = z();
  return (l) => {
    const t = e.getApplicationValue(l.fieldPath);
    switch (l.operation) {
      case "equals":
        return l.fieldValue === t;
      case "not_equals":
        return l.fieldValue !== t;
      case "in":
        return Array.isArray(l.fieldValue) && typeof t == "string" && l.fieldValue.includes(t);
    }
  };
}, dt = (e) => {
  const l = ut();
  return y(() => {
    if (!e.value)
      return !1;
    if (rt(e.value))
      return !0;
    const t = e.value.rules.filter(
      ({ id: i }) => i === "requiredIf"
    );
    if (t.length > 0) {
      for (const i of t)
        if (!l(i))
          return;
      return !0;
    }
  });
}, st = (e) => {
  const l = e.rules.find((t) => t.id === "minLength") || e.rules.find((t) => t.id === "pan");
  if (l?.id === "minLength")
    return l.length;
  if (l?.id === "pan")
    return 8;
}, mt = (e) => {
  const l = e.rules.find((t) => t.id === "maxLength") || e.rules.find((t) => t.id === "pan");
  if (l?.id === "maxLength")
    return l.length;
  if (l?.id === "pan")
    return 19;
}, pt = (e) => {
  const l = e.rules.find((t) => t.id === "validChars") || e.rules.find((t) => t.id === "pan");
  if (l?.id === "validChars") {
    let t = "";
    for (const i of l.validChars)
      i.length === 1 ? t += i.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&") : t += i;
    return new RegExp(`^[${t}]*$`);
  }
  if (l?.id === "pan")
    return /^\d+$/;
}, ct = (e) => {
  const l = e.rules.find(({ id: t }) => t === "min");
  return l?.id === "min" ? l.value : void 0;
}, vt = (e) => {
  const l = e.rules.find(({ id: t }) => t === "max");
  return l?.id === "max" ? l.value : void 0;
}, bt = (e) => {
  const l = e.rules.find(({ id: t }) => t === "maxAge" || t === "minDate");
  if (l?.id === "maxAge") {
    const t = /* @__PURE__ */ new Date();
    return t.setFullYear(t.getFullYear() - l.age), t;
  }
  if (l?.id === "minDate")
    return G(l.value);
}, ft = (e) => {
  const l = e.rules.find(({ id: t }) => t === "minAge" || t === "maxDate");
  if (l?.id === "minAge") {
    const t = /* @__PURE__ */ new Date();
    return t.setFullYear(t.getFullYear() - l.age), t;
  }
  if (l?.id === "maxDate")
    return G(l.value);
}, yt = () => {
  const { t: e } = P({ useScope: "global" }), l = Z();
  return De({
    async validator(t) {
      if (t?.length !== 10)
        return !0;
      try {
        return (await l.validatePhone({
          phoneNumber: t
        })).valid;
      } catch {
        return !1;
      }
    },
    message: () => e("validations.phone")
  });
}, ht = (e) => {
  const l = Z(), { t } = P({ useScope: "global" });
  return D(
    Ee(async (r, p) => {
      if (p === void 0 || r?.length !== 5 && r?.length !== 9)
        return !0;
      try {
        return {
          $valid: (await l.validateZipCode({
            state: p,
            zipCode: r
          })).valid,
          state: p
        };
      } catch {
        return {
          $valid: !1,
          state: p
        };
      }
    }, [e]),
    ({ state: r }) => t("validations.zipCode", {
      state: r
    })
  );
}, me = (e, l) => {
  const { t } = P({ useScope: "global" });
  return D(l, () => t(`validations.${e}`));
}, gt = () => me("pan", (e) => e == null ? !0 : ke(e)), Vt = /\b(?:p\.?\s*o\.?|post\s+office)(\s+)?(?:box|\d*)?\b/i, xt = () => me("noPoBox", (e) => (e?.length ?? 0) > 0 ? !Re(e, Vt) : !0), qt = (e) => {
  const l = z();
  return y(() => {
    if (!e.value)
      return;
    const { path: t, type: i } = e.value;
    if (i !== "zip_code" || t.endsWith(".employerZip"))
      return;
    const r = t.replace(".zipCode", ".state");
    return l.getApplicationValue(r);
  });
}, $t = (e, l) => {
  const t = yt(), i = xt(), r = gt(), p = ht(qt(e));
  Be((d) => {
    if (e.value) {
      const { type: c, rules: m } = e.value, q = {
        // @ts-expect-error this really is a thing: https://reglejs.dev/core-concepts/modifiers#per-field-modifiers
        $debounce: 0
      };
      if (l && Object.assign(q, l(d)), c === "phone" && (q.phone = t), c === "zip_code" && (q.zipCode = p), m.length > 0) {
        const b = (o) => m.some(({ id: F }) => F === o);
        b("noPoBox") && (q.noPoBox = i), b("pan") && (q.pan = r);
      }
      return q;
    }
    return {};
  });
}, pe = (e, l) => {
  $t(e, l);
  const t = dt(e);
  return y(() => e.value?.rules?.length ? {
    disabled: ot(e.value),
    required: t.value,
    minLength: st(e.value),
    maxLength: mt(e.value),
    minValue: ct(e.value),
    maxValue: vt(e.value),
    minDate: bt(e.value),
    maxDate: ft(e.value),
    pattern: pt(e.value)
  } : {});
}, ce = /* @__PURE__ */ Symbol("app-form-state"), ve = /* @__PURE__ */ Symbol("app-form-group-state"), kt = () => {
  const e = S({});
  return K(ce, {
    add(l) {
      e.value[l.id] = l;
    },
    remove(l) {
      delete e.value[l.id];
    }
  }), e;
}, Ft = () => {
  const e = S({});
  return K(ve, {
    add(l) {
      e.value[l.id] = l;
    },
    remove(l) {
      delete e.value[l.id];
    }
  }), e;
}, Ct = (e) => {
  const l = O(ce, void 0), t = O(ve, void 0);
  U(e, (i, r) => {
    r && (l?.remove(r), t?.remove(r)), i && (l?.add(i), t?.add(i));
  }), ae(() => {
    e.value && (l?.add(e.value), t?.add(e.value));
  }), ne(() => {
    e.value && (l?.remove(e.value), t?.remove(e.value));
  });
}, St = (e) => Fe("validation_error", e.code, e.field), Mt = (e, l, t, i) => {
  const r = i && i.length > 0 ? e.error.fieldErrors.filter((d) => i.includes(d.field)) : e.error.fieldErrors;
  if (r.length === 0)
    return !0;
  const p = {};
  return r.forEach((d) => {
    St(d);
    const c = d.code.replace("rule.", "");
    p[d.field] = [
      t(`validations.${c}`) ? l(`validations.${c}`, d.params || {}) : d.message
    ];
  }), p;
}, At = () => {
  const e = Z(), l = z(), t = Ce(), { t: i, te: r } = I({
    useScope: "parent"
  });
  return async (p) => {
    const d = t.fieldProviderKeys;
    try {
      return await e.validateApplication({
        providerKeys: d,
        applicationData: l.application ?? {},
        fieldIds: p
      }), !0;
    } catch (c) {
      if (c instanceof we)
        return Mt(c, i, r, p);
      throw Se(c), c;
    }
  };
}, be = /* @__PURE__ */ Symbol("before-form-submit"), ul = (e) => {
  const l = O(be);
  if (!l)
    throw new Error("BeforeFormSubmit key was not provided");
  return l.onBeforeFormSubmit(e);
}, fe = /* @__PURE__ */ M({
  __name: "YesNoInput",
  props: /* @__PURE__ */ Y({
    id: {},
    name: {},
    label: {},
    helpText: {},
    required: { type: Boolean }
  }, {
    modelValue: { type: Boolean, default: void 0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const l = R(e, "modelValue"), t = y({
      get() {
        return l.value?.toString();
      },
      set(p) {
        typeof p == "string" ? l.value = p === "true" : l.value = void 0;
      }
    }), { t: i } = P(), r = y(() => [
      {
        value: "true",
        label: i("option.yes.label")
      },
      {
        value: "false",
        label: i("option.no.label")
      }
    ]);
    return (p, d) => (g(), k(a(de), {
      id: e.id,
      modelValue: t.value,
      "onUpdate:modelValue": d[0] || (d[0] = (c) => t.value = c),
      name: e.name ?? e.id,
      options: r.value,
      "option-label": (c) => c.label,
      "option-value": (c) => c.value,
      required: e.required,
      label: e.label,
      "help-text": e.helpText
    }, null, 8, ["id", "modelValue", "name", "options", "option-label", "option-value", "required", "label", "help-text"]));
  }
});
function te(e) {
  const l = e;
  l.__i18n = l.__i18n || [], l.__i18n.push({
    locale: "en",
    resource: {
      option: {
        no: {
          label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "No" } }
        },
        yes: {
          label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Yes" } }
        }
      }
    }
  });
}
typeof te == "function" && te(fe);
const Tt = (e) => {
  const l = Xe(), t = y(() => ({
    id: e.value?.id
  }));
  return l?.attach(t.value), U(t, (i, r) => {
    r && l?.detach(r.id), i && l?.attach(i);
  }), ne(() => {
    l?.detach(t.value?.id);
  }), t;
}, It = ["id"], wt = { key: 15 }, Ut = {
  boolean: "checkbox",
  cents: "currency",
  country: "dropdown",
  enum: "dropdown",
  email: "email",
  integer: "number",
  list: "dropdown",
  local_date: "date",
  map: void 0,
  months: "number",
  phone: "phone",
  phone_extension: "phone_extension",
  ssn: "ssn",
  state: "dropdown",
  text: "text",
  years: "number",
  yesNo: "yes-no",
  zip_code: "zip"
}, dl = /* @__PURE__ */ M({
  __name: "AppField",
  props: /* @__PURE__ */ Y({
    label: {},
    helpText: {},
    path: {},
    pathPrefix: {},
    preferredComponent: {},
    required: { type: Boolean },
    disabled: { type: Boolean },
    inputMask: {},
    privacyMode: { type: [String, Function] },
    optionDisabled: { type: Function },
    displayUnit: {}
  }, {
    visible: { type: Boolean },
    visibleModifiers: {},
    modelValue: {
      // Value passed here comes from the parent component's v-model binding
    },
    modelModifiers: {}
  }),
  emits: ["update:visible", "update:modelValue"],
  setup(e) {
    const l = e, t = re(
      () => l.pathPrefix ? `${l.pathPrefix}.${l.path}` : l.path
    ), i = R(e, "visible"), r = se(() => t.value?.path), p = S(!0), d = R(e, "modelValue", {
      // Value passed here comes from the parent component's v-model binding
      get(n) {
        const u = r.value;
        return p.value && u != null && n == null ? d.value = u : u !== n && (r.value = n), p.value = !1, r.value;
      },
      set(n) {
        return r.value !== n && (r.value = n), r.value;
      }
    }), c = nt(t), m = y(() => l.label ?? c.value), q = it(t), b = y(() => l.helpText ?? q.value), o = pe(t), F = I({ useScope: "parent" });
    Ct(t), Tt(t);
    const x = y(() => {
      if (!t.value?.type)
        return;
      const u = l.preferredComponent ?? Ut[t.value.type];
      return u === "dropdown" && l.preferredComponent !== "dropdown" && A.value.length < 4 ? "selectbutton" : u;
    }), A = y(() => {
      if (t.value?.type === "state" && !t.value?.rules.find(({ id: u }) => u === "validOptions"))
        return Me.map((u) => ({
          value: u.id,
          label: u.name
        }));
      if (t.value?.type === "country")
        return Ae.map((u) => ({
          value: u.id,
          label: u.name
        }));
      const n = t.value?.rules?.find(({ id: u }) => u === "validOptions");
      return n?.id === "validOptions" ? n.options.sort((u, s) => u.order - s.order).map((u) => ({
        value: u.value,
        label: F.te(
          `appFields.${t.value?.id}.option.${u.value}.label`
        ) ? F.t(
          `appFields.${t.value?.id}.option.${u.value}.label`
        ) : u.label
      })) : [];
    }), $ = y({
      get() {
        const n = d.value;
        return typeof n == "string" ? n : void 0;
      },
      set(n) {
        d.value = n;
      }
    }), B = y({
      get() {
        const n = d.value;
        return typeof n == "number" ? n : void 0;
      },
      set(n) {
        d.value = n;
      }
    }), T = y({
      get() {
        const n = d.value;
        return typeof n == "number" || typeof n == "string" ? n : void 0;
      },
      set(n) {
        d.value = n;
      }
    }), E = y({
      get() {
        const n = d.value;
        return typeof n == "boolean" ? n : void 0;
      },
      set(n) {
        d.value = n;
      }
    }), H = y({
      get() {
        const n = d.value;
        return typeof n == "string" ? G(n) : void 0;
      },
      set(n) {
        n != null ? d.value = Te(n, "isoDate") : d.value = void 0;
      }
    }), W = y(
      () => t.value?.rules?.find((n) => n.id === "pan") != null
    ), ye = y(() => {
      if (l.inputMask)
        return l.inputMask;
      if (W.value)
        return "9999-9999-9999-9990-000";
    }), X = at(d, () => {
      if (l.privacyMode)
        return l.privacyMode;
      if (W.value)
        return "pan";
    }), he = y(() => {
      const n = w(t)?.path;
      if (n != null)
        switch (n) {
          case "employeeCode":
          case "purchaser.identity.number":
          case "joint.identity.number":
          case "primary.identity.number":
          case "bankAccount.routingNumber":
          case "bankAccount.accountNumber":
            return "numeric";
        }
    });
    return U(
      t,
      (n) => {
        i.value = !!n;
      },
      {
        immediate: !0
      }
    ), U(r, (n) => {
      d.value !== n && (d.value = n);
    }), (n, u) => a(t) ? (g(), C("div", {
      key: 0,
      id: `app-field--${a(t).id}`,
      class: "relative"
    }, [
      x.value === "text" ? (g(), k(a(_), {
        key: 0,
        id: a(t).id,
        modelValue: $.value,
        "onUpdate:modelValue": u[0] || (u[0] = (s) => $.value = s),
        name: a(t).id,
        required: e.required || a(o).required,
        "min-length": a(o).minLength,
        "max-length": a(o).maxLength,
        pattern: a(o).pattern,
        disabled: e.disabled || a(o).disabled,
        "privacy-mask": a(X),
        inputmode: he.value,
        mask: ye.value
      }, {
        label: f(() => [
          v(n.$slots, "label", {}, () => [
            V(h(m.value), 1)
          ])
        ]),
        helpText: f(() => [
          v(n.$slots, "helpText", {}, () => [
            V(h(b.value), 1)
          ])
        ]),
        _: 3
      }, 8, ["id", "modelValue", "name", "required", "min-length", "max-length", "pattern", "disabled", "privacy-mask", "inputmode", "mask"])) : x.value === "signature" ? (g(), k(a(We), {
        key: 1,
        id: a(t).id,
        modelValue: $.value,
        "onUpdate:modelValue": u[1] || (u[1] = (s) => $.value = s),
        name: a(t).id,
        required: e.required || a(o).required,
        disabled: e.disabled || a(o).disabled
      }, null, 8, ["id", "modelValue", "name", "required", "disabled"])) : x.value === "ssn" ? (g(), k(a(Ge), {
        key: 2,
        id: a(t).id,
        modelValue: $.value,
        "onUpdate:modelValue": u[2] || (u[2] = (s) => $.value = s),
        name: a(t).id,
        required: e.required || a(o).required,
        disabled: e.disabled || a(o).disabled
      }, {
        label: f(() => [
          v(n.$slots, "label", {}, () => [
            V(h(m.value), 1)
          ])
        ]),
        helpText: f(() => [
          v(n.$slots, "helpText", {}, () => [
            V(h(b.value), 1)
          ])
        ]),
        _: 3
      }, 8, ["id", "modelValue", "name", "required", "disabled"])) : x.value === "number" ? (g(), k(a(Ke), {
        key: 3,
        id: a(t).id,
        modelValue: B.value,
        "onUpdate:modelValue": u[3] || (u[3] = (s) => B.value = s),
        name: a(t).id,
        required: e.required || a(o).required,
        "min-value": a(o).minValue,
        "max-value": a(o).maxValue,
        "max-length": a(o).maxLength,
        disabled: e.disabled || a(o).disabled,
        type: "integer",
        "privacy-mask": a(X)
      }, {
        label: f(() => [
          v(n.$slots, "label", {}, () => [
            V(h(m.value), 1)
          ])
        ]),
        helpText: f(() => [
          v(n.$slots, "helpText", {}, () => [
            V(h(b.value), 1)
          ])
        ]),
        _: 3
      }, 8, ["id", "modelValue", "name", "required", "min-value", "max-value", "max-length", "disabled", "privacy-mask"])) : x.value === "currency" ? (g(), k(a(je), {
        key: 4,
        id: a(t).id,
        modelValue: B.value,
        "onUpdate:modelValue": u[4] || (u[4] = (s) => B.value = s),
        name: a(t).id,
        required: e.required || a(o).required,
        "min-amount-cents": a(o).minValue,
        "max-amount-cents": a(o).maxValue,
        disabled: e.disabled || a(o).disabled,
        "model-unit": "cents",
        "display-unit": e.displayUnit ?? "dollars"
      }, {
        label: f(() => [
          v(n.$slots, "label", {}, () => [
            V(h(m.value), 1)
          ])
        ]),
        helpText: f(() => [
          v(n.$slots, "helpText", {}, () => [
            V(h(b.value), 1)
          ])
        ]),
        _: 3
      }, 8, ["id", "modelValue", "name", "required", "min-amount-cents", "max-amount-cents", "disabled", "display-unit"])) : x.value === "dropdown" ? (g(), k(a(j), {
        key: 5,
        id: a(t).id,
        modelValue: T.value,
        "onUpdate:modelValue": u[5] || (u[5] = (s) => T.value = s),
        name: a(t).id,
        required: e.required || a(o).required,
        options: A.value,
        "option-label": (s) => s.label,
        "option-value": (s) => s.value,
        "option-disabled": e.optionDisabled,
        "show-clear": a(o).required === void 0,
        disabled: e.disabled || a(o).disabled
      }, {
        label: f(() => [
          v(n.$slots, "label", {}, () => [
            V(h(m.value), 1)
          ])
        ]),
        helpText: f(() => [
          v(n.$slots, "helpText", {}, () => [
            V(h(b.value), 1)
          ])
        ]),
        _: 3
      }, 8, ["id", "modelValue", "name", "required", "options", "option-label", "option-value", "option-disabled", "show-clear", "disabled"])) : x.value === "selectbutton" ? (g(), k(a(de), {
        key: 6,
        id: a(t).id,
        modelValue: T.value,
        "onUpdate:modelValue": u[6] || (u[6] = (s) => T.value = s),
        options: A.value,
        "option-label": (s) => s.label,
        "option-value": (s) => s.value,
        "option-disabled": e.optionDisabled,
        required: e.required || a(o).required,
        disabled: e.disabled || a(o).disabled,
        label: m.value,
        "help-text": b.value
      }, null, 8, ["id", "modelValue", "options", "option-label", "option-value", "option-disabled", "required", "disabled", "label", "help-text"])) : x.value === "zip" ? (g(), k(a(Ye), {
        key: 7,
        id: a(t).id,
        modelValue: $.value,
        "onUpdate:modelValue": u[7] || (u[7] = (s) => $.value = s),
        name: a(t).id,
        required: e.required || a(o).required,
        disabled: e.disabled || a(o).disabled
      }, {
        label: f(() => [
          v(n.$slots, "label", {}, () => [
            V(h(m.value), 1)
          ])
        ]),
        helpText: f(() => [
          v(n.$slots, "helpText", {}, () => [
            V(h(b.value), 1)
          ])
        ]),
        _: 3
      }, 8, ["id", "modelValue", "name", "required", "disabled"])) : x.value === "email" ? (g(), k(a(ue), {
        key: 8,
        id: a(t).id,
        modelValue: $.value,
        "onUpdate:modelValue": u[8] || (u[8] = (s) => $.value = s),
        name: a(t).id,
        required: e.required || a(o).required,
        "min-length": a(o).minLength,
        "max-length": a(o).maxLength,
        disabled: e.disabled || a(o).disabled
      }, {
        label: f(() => [
          v(n.$slots, "label", {}, () => [
            V(h(m.value), 1)
          ])
        ]),
        helpText: f(() => [
          v(n.$slots, "helpText", {}, () => [
            V(h(b.value), 1)
          ])
        ]),
        _: 3
      }, 8, ["id", "modelValue", "name", "required", "min-length", "max-length", "disabled"])) : x.value === "phone" ? (g(), k(a(Ze), {
        key: 9,
        id: a(t).id,
        modelValue: $.value,
        "onUpdate:modelValue": u[9] || (u[9] = (s) => $.value = s),
        name: a(t).id,
        required: e.required || a(o).required,
        disabled: e.disabled || a(o).disabled
      }, {
        label: f(() => [
          v(n.$slots, "label", {}, () => [
            V(h(m.value), 1)
          ])
        ]),
        helpText: f(() => [
          v(n.$slots, "helpText", {}, () => [
            V(h(b.value), 1)
          ])
        ]),
        _: 3
      }, 8, ["id", "modelValue", "name", "required", "disabled"])) : x.value === "date" ? (g(), k(a(He), {
        key: 10,
        id: a(t).id,
        modelValue: H.value,
        "onUpdate:modelValue": u[10] || (u[10] = (s) => H.value = s),
        required: e.required || a(o).required,
        "min-date": a(o).minDate,
        "max-date": a(o).maxDate,
        disabled: e.disabled || a(o).disabled
      }, {
        label: f(() => [
          v(n.$slots, "label", {}, () => [
            V(h(m.value), 1)
          ])
        ]),
        helpText: f(() => [
          v(n.$slots, "helpText", {}, () => [
            V(h(b.value), 1)
          ])
        ]),
        _: 3
      }, 8, ["id", "modelValue", "required", "min-date", "max-date", "disabled"])) : x.value === "checkbox" ? (g(), k(a(Oe), {
        key: 11,
        id: a(t).id,
        modelValue: E.value,
        "onUpdate:modelValue": u[11] || (u[11] = (s) => E.value = s),
        required: e.required || a(o).required,
        disabled: e.disabled || a(o).disabled
      }, {
        label: f(() => [
          v(n.$slots, "label", {}, () => [
            V(h(m.value), 1)
          ])
        ]),
        helpText: f(() => [
          v(n.$slots, "helpText", {}, () => [
            V(h(b.value), 1)
          ])
        ]),
        _: 3
      }, 8, ["id", "modelValue", "required", "disabled"])) : x.value === "yes-no" ? (g(), k(fe, {
        key: 12,
        id: a(t).id,
        modelValue: E.value,
        "onUpdate:modelValue": u[12] || (u[12] = (s) => E.value = s),
        name: a(t).id,
        label: m.value,
        "help-text": b.value,
        required: e.required || a(o).required,
        disabled: e.disabled || a(o).disabled
      }, {
        label: f(() => [
          v(n.$slots, "label", {}, () => [
            V(h(m.value), 1)
          ])
        ]),
        helpText: f(() => [
          v(n.$slots, "helpText", {}, () => [
            V(h(b.value), 1)
          ])
        ]),
        _: 3
      }, 8, ["id", "modelValue", "name", "label", "help-text", "required", "disabled"])) : x.value === "phone_extension" ? (g(), k(a(_), {
        key: 13,
        id: a(t).id,
        modelValue: $.value,
        "onUpdate:modelValue": u[13] || (u[13] = (s) => $.value = s),
        type: "tel",
        name: a(t).id,
        required: e.required || a(o).required,
        "min-length": 3,
        "max-length": 6,
        pattern: /\d{3,6}/,
        disabled: e.disabled || a(o).disabled
      }, {
        label: f(() => [
          v(n.$slots, "label", {}, () => [
            V(h(m.value), 1)
          ])
        ]),
        helpText: f(() => [
          v(n.$slots, "helpText", {}, () => [
            V(h(b.value), 1)
          ])
        ]),
        _: 3
      }, 8, ["id", "modelValue", "name", "required", "disabled"])) : x.value === "country" ? (g(), k(a(j), {
        key: 14,
        id: a(t).id,
        modelValue: T.value,
        "onUpdate:modelValue": u[14] || (u[14] = (s) => T.value = s),
        name: a(t).id,
        required: e.required || a(o).required,
        options: A.value,
        "option-label": (s) => s.label,
        "option-value": (s) => s.value,
        "option-disabled": e.optionDisabled,
        "show-clear": a(o).required === void 0,
        disabled: e.disabled || a(o).disabled
      }, null, 8, ["id", "modelValue", "name", "required", "options", "option-label", "option-value", "option-disabled", "show-clear", "disabled"])) : (g(), C("span", wt, "Not implemented: " + h(a(t).type), 1)),
      v(n.$slots, "description")
    ], 8, It)) : L("", !0);
  }
}), sl = /* @__PURE__ */ M({
  __name: "AppForm",
  props: {
    id: {},
    submitting: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["submit"],
  setup(e, { emit: l }) {
    const t = l, i = S(!1), r = kt(), p = At(), d = S(/* @__PURE__ */ new Set());
    function c(o) {
      return d.value.add(o), {
        off: () => {
          d.value.delete(o);
        },
        submit: b
      };
    }
    const m = async () => {
      i.value = !0;
      const o = Object.keys(r.value), F = await p(o);
      for (const x of d.value)
        if (!await x())
          return i.value = !1, {};
      return i.value = !1, F;
    }, q = async () => {
      t("submit");
    }, b = async () => {
      await m() === !0 && await q();
    };
    return K(be, {
      onBeforeFormSubmit: c
    }), (o, F) => (g(), k(a(Je), {
      id: e.id,
      disabled: e.disabled || i.value,
      submitting: e.submitting || i.value,
      "before-submit": m,
      class: "flex h-full flex-col",
      onSubmit: q
    }, {
      default: f((x) => [
        v(o.$slots, "default", ge(Ve(x)))
      ]),
      _: 3
    }, 8, ["id", "disabled", "submitting"]));
  }
}), ml = /* @__PURE__ */ M({
  __name: "AppFormGroup",
  setup(e) {
    const l = Ft(), t = y(() => Object.keys(l.value).length > 0);
    return (i, r) => xe((g(), C("div", null, [
      v(i.$slots, "default")
    ], 512)), [
      [qe, t.value]
    ]);
  }
}), Dt = /* @__PURE__ */ M({
  __name: "TestCaseChooser",
  emits: ["selected"],
  setup(e, { emit: l }) {
    const t = Ie(), { t: i } = I(), r = S(t.testCase?.id), p = S(!1), d = y(() => (t.testCases.length ?? 0) > 0), c = l, m = () => {
      d.value && (p.value = !0);
    }, q = () => {
      const o = r.value, F = o != null ? t.testCases.find((x) => x.id === o) : void 0;
      F && c("selected", F);
    }, b = () => {
      r.value = void 0;
    };
    return (o, F) => {
      const x = j, A = Qe;
      return g(), C(ie, null, [
        N(A, {
          modelValue: p.value,
          "onUpdate:modelValue": F[1] || (F[1] = ($) => p.value = $),
          header: "Test Case",
          "cancel-button-label": a(i)("buttons.cancel"),
          "accept-button-label": a(i)("buttons.accept"),
          onModalAccept: q,
          onModalReject: b
        }, {
          default: f(() => [
            N(x, {
              id: "testCases",
              modelValue: r.value,
              "onUpdate:modelValue": F[0] || (F[0] = ($) => r.value = $),
              options: a(t).testCases,
              "option-label": ($) => $.name,
              "option-value": ($) => $.id
            }, null, 8, ["modelValue", "options", "option-label", "option-value"])
          ]),
          _: 1
        }, 8, ["modelValue", "cancel-button-label", "accept-button-label"]),
        oe("div", {
          class: $e({
            "cursor-pointer": d.value
          }),
          onClickCapture: m
        }, [
          v(o.$slots, "default")
        ], 34)
      ], 64);
    };
  }
});
function le(e) {
  const l = e;
  l.__i18n = l.__i18n || [], l.__i18n.push({
    locale: "en",
    resource: {
      buttons: {
        accept: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Select" } },
        cancel: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Cancel" } }
      }
    }
  });
}
typeof le == "function" && le(Dt);
const Pt = { class: "flex flex-col gap-2 lg:w-90" }, Bt = ["for"], Et = { key: 0 }, pl = /* @__PURE__ */ M({
  __name: "BoringPaymentCalculatorInput",
  props: /* @__PURE__ */ Y({
    id: {},
    currencyMode: { default: "dollars" },
    minValue: { default: void 0 },
    maxValue: { default: void 0 },
    disabled: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const l = R(e, "modelValue"), t = e, i = y({
      get() {
        if (l.value != null)
          return t.currencyMode === "cents" ? l.value / 100 : l.value;
      },
      set(m) {
        if (m == null) {
          l.value = void 0;
          return;
        }
        t.currencyMode === "cents" ? l.value = m * 100 : l.value = m;
      }
    }), { t: r, te: p } = I({
      useScope: "parent"
    }), d = (m) => p(`validations.${t.id}.${m}`) ? `validations.${t.id}.${m}` : `validations.${m}`, { r$: c } = Pe(l, () => ({
      maxValue: D(
        Ne(() => t.maxValue),
        () => r(d("maxValue"), {
          max: J(t.maxValue, t.currencyMode)
        })
      ),
      minValue: D(
        Le(() => t.minValue),
        () => r(d("minValue"), {
          min: J(t.minValue, t.currencyMode)
        })
      )
    }));
    return ae(() => c.$touch()), (m, q) => (g(), C(ie, null, [
      oe("div", Pt, [
        m.$slots.label ? (g(), C("label", {
          key: 0,
          for: e.id,
          class: "text-sm text-surface-600"
        }, [
          v(m.$slots, "label")
        ], 8, Bt)) : L("", !0),
        N(a(_e), {
          modelValue: i.value,
          "onUpdate:modelValue": q[0] || (q[0] = (b) => i.value = b),
          "input-id": e.id,
          invalid: a(c).$invalid,
          disabled: e.disabled,
          "input-class": [
            "text-center !text-xl font-semibold",
            {
              "!text-primary-600 ": !a(c).$invalid,
              "!text-danger-600": a(c).$invalid
            }
          ],
          currency: "USD",
          mode: "currency"
        }, null, 8, ["modelValue", "input-id", "invalid", "disabled", "input-class"])
      ]),
      a(c).$errors.length ? (g(), C("p", Et, [
        N(a(et), {
          class: "relative!",
          for: e.id,
          "active-error": a(c).$errors[0]
        }, null, 8, ["for", "active-error"])
      ])) : L("", !0)
    ], 64));
  }
}), cl = /* @__PURE__ */ M({
  __name: "ConfirmEmailField",
  props: {
    applicantType: { default: Ue.PRIMARY },
    id: { default: void 0 }
  },
  setup(e) {
    const l = e, t = se(() => `${l.applicantType}.email`), i = re(
      () => `${l.applicantType}.email`
    ), r = (q) => `validations.${q}`, { t: p } = P({
      useScope: "parent"
    }), d = y(() => i.value ? {
      ...i.value,
      id: `${l.applicantType}ConfirmEmail`,
      name: `${l.applicantType}ConfirmEmail`
    } : null), c = D(
      ze(
        (q, b) => Q(q) || Q(b) ? !0 : q === b,
        [t]
      ),
      () => p(r("emailMatch"))
    ), m = pe(
      d,
      () => ({ emailMatch: c })
    );
    return (q, b) => {
      const o = ue;
      return d.value ? (g(), k(o, {
        key: 0,
        id: d.value.id,
        label: a(p)("appFields.confirmEmail.label"),
        required: a(m).required,
        "min-length": a(m).minLength,
        "max-length": a(m).maxLength,
        disabled: a(m).disabled,
        class: "w-full"
      }, null, 8, ["id", "label", "required", "min-length", "max-length", "disabled"])) : L("", !0);
    };
  }
});
export {
  be as B,
  dl as _,
  yt as a,
  sl as b,
  ml as c,
  pl as d,
  cl as e,
  Dt as f,
  ul as g,
  se as u
};
//# sourceMappingURL=index-DDh84FJX.js.map
